import { createApp, defineAsyncComponent } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './bootstrap'
import './icons'

window.addEventListener('DOMContentLoaded', () => {
	const Vue = createApp({})

	Vue.config.devtools = true

	Vue.component('fa-icon', FontAwesomeIcon)
	Vue.component('trail-map', defineAsyncComponent(() => import(/* webpackPrefetch: true */'./components/TrailMap.vue')))
	Vue.component('trail-map-marker', defineAsyncComponent(() => import(/* webpackPrefetch: true */'./components/TrailMapMarker')))
	Vue.component('trail-map-image', defineAsyncComponent(() => import(/* webpackPrefetch: true */'./components/TrailMapImage.vue')))

	Vue.mount('#app')
})
